import { GridColDef } from "@mui/x-data-grid";
import "../../css/global.css";

interface ColumnsProps {
  handleVerClick: (uuid: string, link: string) => void;
  urlOrigen?: string;
  rows: any[]; // 🔥 IMPORTANTE: Ahora recibes rows
}

const getColumnsVerificacionPF = ({
  handleVerClick,
  urlOrigen,
  rows
}: ColumnsProps): GridColDef[] => {
  const formatNumber = (value: any) => {
    if (!value) return '';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const columns: GridColDef[] = [
    {
      field: "municipio",
      headerName: "Municipios",
      width: 150,
      hideable: false,
      headerAlign: "left",
      align: "left",
      renderCell: (cellValues: any) => {
        return <p>{cellValues.row.municipio}</p>;
      },
    },
    {
      field: "FGP",
      headerName: "Fondo General Participaciones",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.FGP)}</p>;
      },
    },
    {
      field: "70% FFM",
      headerName: "Fondo de Fomento Municipal 70 % (FFM70)",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "30% FFM",
      headerName: "Fondo de Fomento Municipal 30 % (FFM30)",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "IEPS",
      headerName: "Impuesto Especial sobre la Producción y los Servicios (IEPS)",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.IEPS)}</p>;
      },
    },
    {
      field: "FOFIR",
      headerName: "Fondo de Fiscalización y Recaudación",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.FOFIR)}</p>;
      },
    },
    {
      field: "ISAN",
      headerName: "Impuesto sobre Automoviles Nuevos (ISAN)",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.ISAN)}</p>;
      },
    },
    {
      field: "COMP ISAN",
      headerName: "Fondo de Compensación de ISAN",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "IEPSGYD",
      headerName: "Impuesto Especial sobre la Venta Final de Gasolina y Diésel (IEPSGyD)",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.IEPSGYD)}</p>;
      },
    },
    {
      field: "FEXHI",
      headerName: "Fondo de Extracción de Hidrocarburos",
      width: 300,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "ISR BI",
      headerName: "ISR por Enajenación de Bienes Inmuebles",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "ISR SALARIOS",
      headerName: "ISR Salarios",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "TENENCIA",
      headerName: "Tenencia",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "FEIEF FGP",
      headerName: "FEIEF Fondo General Participaciones",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "FEIEF FOFIR",
      headerName: "FEIEF Fondo de Fiscalización y Recaudación",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "FEIEF FFM70",
      headerName: "FEIEF Fondo de Fomento Municipal 70 % (FFM70)",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "FEIEF IEPS",
      headerName: "FEIEF Impuesto Especial sobre la Producción y los Servicios (IEPS)",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "total_monto",
      headerName: "Totales",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.total_monto)}</p>;
      },
    },
  ];

  // 🔥 Aquí filtramos las columnas que sí tengan valores en rows
  const filteredColumns = columns.filter(col =>
    rows.some(row => row[col.field] !== undefined && row[col.field] !== null)
  );

  return filteredColumns;
};

export default getColumnsVerificacionPF;
